// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__RJksq","title":"style_title__WwmfL","text":"style_text__Gddtu","oneLine":"style_oneLine__TVX8K"};